import React from 'react';
import { Linkedin, Twitter, Mail, Phone, MessageCircle } from 'lucide-react';
import { mockData } from '../mock/consultingData';
import { Link, useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();

  const scrollToTopAndNavigate = (path) => {
    navigate(path);
    // Small delay to ensure navigation completes before scrolling
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  };
  return (
    <footer className="dark-section border-t border-gray-800">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16 mb-12">
          {/* Company Info */}
          <div>
            <div className="mb-6">
              {/* Logo and Company Name */}
              <div className="flex items-center gap-4 mb-4">
                <div className="w-20 h-20 md:w-24 md:h-24 lg:w-28 lg:h-28 rounded-lg p-2 flex items-center justify-center">
                  <img 
                    src="/shanso-logo-transparent.png"
                    alt="ShansoConsult Logo"
                    className="w-full h-full object-contain"
                  />
                </div>
                <h3 className="text-2xl md:text-3xl font-bold text-turquoise-400">ShansoConsult</h3>
              </div>
              <p className="body-medium mb-4">
                Driving operational excellence and digital transformation with proven methodologies 
                and innovative solutions across industries.
              </p>
              
              <div className="mb-6">
                <button
                  onClick={() => {
                    const message = `Hello! I'd like to connect with ShansoConsult for professional consulting services.`;
                    window.open(`https://wa.me/919962536379?text=${encodeURIComponent(message)}`, '_blank');
                  }}
                  className="inline-flex items-center gap-2 bg-green-600 hover:bg-green-500 text-white px-4 py-2 transition-colors duration-300"
                >
                  <MessageCircle size={16} />
                  <span className="body-small font-medium">WhatsApp: +91 9962536379</span>
                </button>
              </div>
            </div>
            
            <div className="flex gap-4">
              <a 
                href="https://www.linkedin.com/in/shunmugavels" 
                target="_blank" 
                rel="noopener noreferrer"
                className="p-2 bg-gray-800 hover:bg-turquoise-600 transition-colors duration-300"
              >
                <Linkedin size={20} />
              </a>
              <a 
                href="https://twitter.com/shansography" 
                target="_blank" 
                rel="noopener noreferrer"
                className="p-2 bg-gray-800 hover:bg-turquoise-600 transition-colors duration-300"
              >
                <Twitter size={20} />
              </a>
              <a 
                href={`mailto:${mockData.contact.email}`}
                className="p-2 bg-gray-800 hover:bg-turquoise-600 transition-colors duration-300"
              >
                <Mail size={20} />
              </a>
              <a 
                href={`tel:${mockData.contact.phone}`}
                className="p-2 bg-gray-800 hover:bg-turquoise-600 transition-colors duration-300"
              >
                <Phone size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="heading-3 mb-6">Quick Links</h4>
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-3">
                <a href="#services" className="body-medium text-muted hover:text-primary transition-colors block">
                  Services
                </a>
                <a href="#case-studies" className="body-medium text-muted hover:text-primary transition-colors block">
                  Case Studies
                </a>
                <a href="#insights" className="body-medium text-muted hover:text-primary transition-colors block">
                  Insights
                </a>
                <a href="#about" className="body-medium text-muted hover:text-primary transition-colors block">
                  About
                </a>
              </div>
              <div className="space-y-3">
                <a href="#contact" className="body-medium text-muted hover:text-primary transition-colors block">
                  Contact
                </a>
                <button 
                  onClick={() => scrollToTopAndNavigate('/privacy-policy')}
                  className="body-medium text-muted hover:text-primary transition-colors block text-left bg-transparent border-0 p-0 cursor-pointer"
                >
                  Privacy Policy
                </button>
                <button 
                  onClick={() => scrollToTopAndNavigate('/terms-of-service')}
                  className="body-medium text-muted hover:text-primary transition-colors block text-left bg-transparent border-0 p-0 cursor-pointer"
                >
                  Terms of Service
                </button>
                <button 
                  onClick={() => scrollToTopAndNavigate('/disclaimer')}
                  className="body-medium text-muted hover:text-primary transition-colors block text-left bg-transparent border-0 p-0 cursor-pointer"
                >
                  Disclaimer
                </button>
                <button 
                  onClick={() => scrollToTopAndNavigate('/community/guidelines')}
                  className="body-medium text-muted hover:text-primary transition-colors block text-left bg-transparent border-0 p-0 cursor-pointer"
                >
                  Community Guidelines
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center">
          <p className="body-small text-muted">
            © 2025 ShansoConsult. All rights reserved.
          </p>
          <p className="body-small text-muted">
            Excellence • Compliance • Transformation
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;